
import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-primary text-slate-300 pt-24 pb-12 px-6 md:px-8 font-geist">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-16 pb-20 border-b border-white/5">

          <div className="col-span-1 lg:col-span-4">
            <div className="mb-12">
              <img
                src="https://ik.imagekit.io/6dlukcyok/Medical%20bucket/Gemini_Generated_Image_aaa78eaaa78eaaa7-removebg-preview.png"
                alt="Dr Du Plessis Logo"
                className="h-40 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-base leading-relaxed text-slate-400 mb-8 max-w-sm">
              Dr CG Du Plessis & Partners. Trusted general medical care in a calm, professional environment.
            </p>
            <div className="flex gap-4">
              <a href="https://www.facebook.com/drcgduplessis/about/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-accent hover:text-white transition-colors border border-white/10 hover:border-accent">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M9.198 21.5h4v-8.01h3.604l.396-3.98h-4V7.5a1 1 0 0 1 1-1h3v-4h-3a5 5 0 0 0-5 5v2.01h-2l-.396 3.98h2.396v8.01Z" /></svg>
              </a>
              <a href="mailto:fourwaysdoctor@gmail.com" aria-label="Email Us" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-accent hover:text-white transition-colors border border-white/10 hover:border-accent">
                <span className="material-symbols-outlined text-xl">mail</span>
              </a>
            </div>
          </div>

          <div className="col-span-1 lg:col-span-2">
            <h5 className="text-white font-bold mb-10 uppercase text-xs tracking-[0.2em]">Services</h5>
            <ul className="space-y-5 text-sm font-medium">
              <li><Link to="/services" className="hover:text-accent transition-colors">General Medical Exams</Link></li>
              <li><Link to="/services" className="hover:text-accent transition-colors">Chronic Disease</Link></li>
              <li><Link to="/services" className="hover:text-accent transition-colors">Acute Consults</Link></li>
              <li><Link to="/services" className="hover:text-accent transition-colors">Women's Health</Link></li>
              <li><Link to="/services" className="hover:text-accent transition-colors">Men's Health</Link></li>
              <li><Link to="/services" className="hover:text-accent transition-colors">Children's Health</Link></li>
              <li><Link to="/services" className="hover:text-accent transition-colors">Geriatric Care</Link></li>
              <li><Link to="/services" className="hover:text-accent transition-colors">Minor Procedures</Link></li>
              <li><Link to="/services" className="hover:text-accent transition-colors">Nursing Services</Link></li>
              <li><Link to="/services" className="hover:text-accent transition-colors">IV Wellness Therapy</Link></li>
            </ul>
          </div>

          <div className="col-span-1 lg:col-span-3">
            <h5 className="text-white font-bold mb-10 uppercase text-xs tracking-[0.2em]">Practice Info</h5>
            <ul className="space-y-6 text-sm text-slate-400">
              <li className="flex items-start gap-4">
                <span className="material-symbols-outlined text-accent text-xl mt-0.5">location_on</span>
                <span className="leading-relaxed">39 Kingfisher Drive,<br />Kingfisher Shopping Centre,<br />Fourways, Sandton</span>
              </li>
              <li className="flex items-center gap-4">
                <span className="material-symbols-outlined text-accent text-xl">schedule</span>
                <div>
                  <span className="block text-white">Mon - Fri:</span>
                  8:00 am – 5:00 pm
                  <span className="block text-white mt-2">Saturday:</span>
                  9:00 am – 1:00 pm
                </div>
              </li>
            </ul>
          </div>

          <div className="col-span-1 lg:col-span-3">
            <h5 className="text-white font-bold mb-10 uppercase text-xs tracking-[0.2em]">Contact</h5>
            <ul className="space-y-6 text-sm text-slate-400">
              <li className="flex items-center gap-4">
                <span className="material-symbols-outlined text-accent text-xl">call</span>
                <a href="tel:0117052197" className="hover:text-white transition-colors">011 705 2197</a>
              </li>
              <li className="flex items-center gap-4">
                <span className="material-symbols-outlined text-accent text-xl">mail</span>
                <a href="mailto:fourwaysdoctor@gmail.com" className="hover:text-white transition-colors break-all">fourwaysdoctor@gmail.com</a>
              </li>
            </ul>
          </div>

        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-10 pt-12">
          <p className="text-[10px] text-slate-500 font-bold uppercase tracking-[0.2em]">© 2026 Dr CG Du Plessis & Partners. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};
